import React, { Component } from 'react'

export class Quiz extends Component {
    render() {
        return (
            <div>
                This Feature will come in the Beta version.
            </div>
        )
    }
}

export default Quiz
